import template from './template.html';
import angular from 'angular';

class EmployerInsightLinkComponent {
    constructor($state) {
        const employerInsightLinkCtrl = this;
        employerInsightLinkCtrl.getInsightLinkUrl = () => {
            return $state.href('insightReport', {positionId: this.positionId});
        }
    }
}

const ComponentConfiguration = {
    template,
    bindings: {
        positionId: '=',
    },
    controller: EmployerInsightLinkComponent,
    controllerAs: 'employerInsightLinkCtrl',
};

angular
    .module('TALENYA-FE')
    .component('employerInsightLinkComponent', ComponentConfiguration);
